exports.ClientToolView = {
  path: '/clienttools',
  name: 'ClientToolView'
}
